import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ApplyForCreditModalContent from './ApplyForCreditModalContent';
import CommonModal from '../CommonModal/CommonModal';
import useSaveBuild from '../../core/apiHooks/useSaveBuild';
import useSummaryCard from '../BapSummaryCard/hooks/useSummaryCard';
import { APPLY_FOR_CREDIT_URL } from '../../utils/constants';
import { navigateTo } from '../../utils/common';
import { removeAllTagsFromMarkdown } from '../../utils/markdown';
import { useSharedApps } from '../../utils/sitecoreContext';
const ApplyForCreditModal = ({ showModal, closeModal, isSalesTaxIncluded }) => {
    var _a;
    const { t } = useTranslation();
    const [buildName, setBuildName] = useState('');
    const { nameBadge, vehicle, modelImage, bigExteriorImage } = useSummaryCard();
    const applyForCreditUrl = useSharedApps(APPLY_FOR_CREDIT_URL);
    const modelName = vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelName;
    const modelYear = vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelYear;
    const trimName = vehicle === null || vehicle === void 0 ? void 0 : vehicle.trimName;
    const transmissionName = (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmission) === null || _a === void 0 ? void 0 : _a.transmissionName;
    const defaultBuildName = removeAllTagsFromMarkdown(`${modelYear} ${modelName} - ${trimName} ${transmissionName}`.toUpperCase()) || '';
    const { saveBuild, isProcessing } = useSaveBuild(!buildName ? defaultBuildName : buildName, true);
    function handleSubmit() {
        saveBuild({
            onSuccess({ buildKey, isUserLoggedIn, redirectUrl }) {
                ApplyForCreditModal.navigateTo(isUserLoggedIn ? `${applyForCreditUrl}/${buildKey}` : redirectUrl);
            },
        });
    }
    function handleCloseModal() {
        closeModal();
        setBuildName('');
    }
    return (React.createElement(CommonModal, { showModal: showModal, handleSubmit: handleSubmit, title: t('Pages.Bap.applyCreditModalHeading'), handleCloseModal: handleCloseModal, dataTestId: "cy-ApplyForCreditModal", primaryButtonText: t('Pages.Bap.saveButton'), secondaryButtonText: t('Pages.Bap.doNotSaveButton'), childrenProps: { noPadding: true }, submitButtonEnabled: !isProcessing },
        React.createElement(ApplyForCreditModalContent, { vehicleImage: modelImage, modelBadgeImage: nameBadge, inputFieldValue: buildName, onInputFieldChange: value => setBuildName(value), closeModal,
            vehicle,
            bigExteriorImage,
            isSalesTaxIncluded,
            defaultBuildName })));
};
export default ApplyForCreditModal;
ApplyForCreditModal.navigateTo = navigateTo;
